interface EyeOffIconProps {
  className?: string
  size?: number
}

export const EyeOffIcon = ({ className, size = 24 }: EyeOffIconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.88 9.88a3 3 0 1 0 4.24 4.24"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10.73 5.08A10.43 10.43 0 0 1 12 5c4.478 0 8.268 2.943 9.542 7a10.47 10.47 0 0 1-1.63 2.86"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6.61 6.61A10.54 10.54 0 0 0 2.458 12C3.732 16.057 7.523 19 12 19a10.43 10.43 0 0 0 5.39-1.51"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M2 2l20 20"
      />
    </svg>
  )
}
